import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Side-effect import: hardens Chart.js tooltip against stale-active crashes.
// Must run before any chart renders.
import './utils/chartSafetyPatch';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { BooksProvider } from './contexts/BooksContext';
import { AuthProvider } from './contexts/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/DarkMode.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DarkModeProvider>
        <BooksProvider>
          <App />
        </BooksProvider>
      </DarkModeProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
